import React from 'react';
import PricingTable from '.';
import { useTranslation } from 'react-i18next';

export default function PricingTableList() {
  const { t } = useTranslation();
  
  return (
    <div className="cs_tabs cs_style1">
      <div className="row cs_gap_y_30">
        <div className="col-lg-4">
          <PricingTable
            title={t('pricing.packages.starter.title')}
            subTitle={t('pricing.packages.starter.subTitle')}
            price={t('pricing.packages.starter.price')}
            currency={t('pricing.packages.starter.currency')}
            features={t('pricing.packages.starter.features', { returnObjects: true })}
            btnText={t('pricing.packages.starter.btnText')}
            btnLink="/"
          />
        </div>
        <div className="col-lg-4">
          <PricingTable
            title={t('pricing.packages.growth.title')}
            subTitle={t('pricing.packages.growth.subTitle')}
            price={t('pricing.packages.growth.price')}
            currency={t('pricing.packages.growth.currency')}
            features={t('pricing.packages.growth.features', { returnObjects: true })}
            btnText={t('pricing.packages.growth.btnText')}
            btnLink="/"
            popular
          />
        </div>
        <div className="col-lg-4">
          <PricingTable
            title={t('pricing.packages.elite.title')}
            subTitle={t('pricing.packages.elite.subTitle')}
            price={t('pricing.packages.elite.price')}
            currency={t('pricing.packages.elite.currency')}
            features={t('pricing.packages.elite.features', { returnObjects: true })}
            btnText={t('pricing.packages.elite.btnText')}
            btnLink="/"
          />
        </div>
      </div>
    </div>
  );
}